import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../components/table/styled-table";
import MembershipTableRow from "./membership-table-row";
import { Membership } from "../../../service/model/membership.model";
import { configs } from "../../../app/app-configs";
import { useAppSelector } from "../../../app/hooks";
import { selectIsLoading } from "../membership.slice";

const headers: ColumnHeader[] = [
    { name: "Name" },
    { name: "Price" },
    { name: "Duration (Days)" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly memberships: Membership[]
}

const MembershipTable: React.FC<TableProps> = ({ memberships }) => {
    const isLoading = useAppSelector(selectIsLoading);
    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(memberships.length / configs.PAGE_SIZE);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            loading={isLoading}
            emptyMessage="No memberships found"
            onPageChange={handlePageChange}>

            {(configs.PAGE_SIZE > 0
                ? memberships.slice((page - 1) * configs.PAGE_SIZE, (page - 1) * configs.PAGE_SIZE + configs.PAGE_SIZE)
                : memberships
            )?.map(membership =>
                <MembershipTableRow membership={membership} key={membership.id} />
            )}
        </StyledTable>
    );
}

export default MembershipTable;